import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';
import { NavLink, NavLinkRenderProps } from 'react-router-dom';

import CheckIcon from '@/assets/icons/check.svg?react';
import { useTranslator } from '@/hooks/useTranslator';
import { Status } from '@/types/steps';

interface Props {
  readonly path: string;
  readonly title: string;

  readonly status?: Status;
}

export const ChildStepProgressLabel: React.FC<Props> = (props: Props): React.ReactElement => {
  const { path, title, status } = props;

  const tr = useTranslator();
  const renderText = React.useCallback(
    (status: NavLinkRenderProps): React.ReactElement => {
      return (
        <Typography variant="body1" color={status.isActive ? 'text.primary' : 'custom.Inactive'}>
          {tr(title)}
        </Typography>
      );
    },
    [title, tr],
  );

  return (
    <Box role="button" sx={styles.container}>
      <NavLink to={['..', path].join('/')} relative="path">
        {renderText}
      </NavLink>
      {status === Status.completed && (
        <Box ml="auto" height={24}>
          <CheckIcon fill="currentColor" />
        </Box>
      )}
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 24,
    pl: 5,
  },
};
